import { useEffect, } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createMRTColumnHelper } from "material-react-table";
import CustomTable from "../../components/customTable/CustomTable";
import { IconButton,  Tooltip } from "@mui/material";
import FindTotalCommission from "./FindTotalCommission";
import { parnerReportCommissionApi } from "../../app/slices/parnerReportCommissionSlice";
import { toast } from "react-toastify";
import { ContentCopy,  } from "@mui/icons-material"; // Import the copy icon from MUI


export default function PartnerReportCard() {
  const dispatch = useDispatch();
  const roleResponse = useSelector((state) => state.login.login.role);

  useEffect(() => {
    dispatch(parnerReportCommissionApi());
  }, [dispatch]);

  const sliceResponse = useSelector(
    (state) => state.parnerReportCommission.parnerReportCommission.data
  );
  const stateLoading = useSelector(
    (state) => state.parnerReportCommission.loading
  );

  const columnHelper = createMRTColumnHelper();
  const columns = [
    columnHelper.accessor("_id", {
      header: "ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?._id);
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?._id}>
            <IconButton onClick={handleCopy}>
              <ContentCopy />
            </IconButton>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("name", {
      header: "Name",
      size: 30,
      Cell: (cell) => cell.row.original?.name,
    }),
    columnHelper.accessor("username", {
      header: "Username",
      size: 30,
      Cell: (cell) => cell.row.original?.username,
    }),
    columnHelper.accessor("totalCommission", {
      header: "Total Commission",
      size: 30,
      Cell: (cell) => cell.row.original?.totalCommission,
    }),
    columnHelper.accessor("commission_per", {
      header: "Partner Commission",
      size: 30,
      Cell: (cell) => cell.row.original?.commission_per,
    }),
    columnHelper.accessor("isBlocked", {
      header: "Blocked",
      size: 30,
      Cell: (cell) => (cell.row.original?.isBlocked == "false" ? "Yes" : "No"),
    }),
    columnHelper.accessor("is_deleted", {
      header: "Deleted",
      size: 30,
      Cell: (cell) => (cell.row.original?.is_deleted == "false" ? "Yes" : "No"),
    }),

  ];
  return (
    <>
   {/*  */}
      {roleResponse?.PartnerReport?.update === 1 && <FindTotalCommission sliceResponse={sliceResponse}/>}
       <CustomTable columns={columns} data={sliceResponse}   loading={stateLoading} permissionKey="PartnerReport"/>
      

    </>
  );
}
